(function () {
  const drawer = document.querySelector('[data-fb-cart-drawer]');
  if (!drawer) return;

  const body = drawer.querySelector('[data-fb-cart-body]');
  const itemsRoot = drawer.querySelector('[data-fb-cart-items]');
  const emptyState = drawer.querySelector('[data-fb-cart-empty]');
  const footer = drawer.querySelector('[data-fb-cart-footer]');
  const countEl = drawer.querySelector('[data-fb-cart-count]');
  const subtotalEl = drawer.querySelector('[data-fb-cart-subtotal]');
  const checkoutBtn = drawer.querySelector('[data-fb-cart-checkout]');
  const openTriggers = document.querySelectorAll('[data-fb-cart-open]');
  const closeTriggers = drawer.querySelectorAll('[data-fb-cart-close]');
  const headerCount = document.querySelector('[data-fb-header-cart-count]');
  const moneyFormat = drawer.dataset.moneyFormat || '${{amount}}';

  let isOpen = false;
  let isLoading = false;

  const formatMoney = (cents) => {
    const amount = (cents / 100).toFixed(2);
    if (moneyFormat.includes('{{amount_with_comma_separator}}')) {
      return moneyFormat.replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
    }
    if (moneyFormat.includes('{{amount_no_decimals}}')) {
      return moneyFormat.replace('{{amount_no_decimals}}', String(Math.round(cents / 100)));
    }
    if (moneyFormat.includes('{{amount}}')) {
      return moneyFormat.replace('{{amount}}', amount);
    }
    return `$${amount}`;
  };

  const escapeHtml = (value) =>
    String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

  const setHeaderCount = (count) => {
    if (!headerCount) return;
    if (count > 0) {
      headerCount.textContent = String(count);
      headerCount.hidden = false;
    } else {
      headerCount.textContent = '';
      headerCount.hidden = true;
    }
  };

  const renderItem = (item) => {
    const variant =
      item.variant_title && item.variant_title !== 'Default Title'
        ? `<p class="fb-cart-drawer__item-variant">${escapeHtml(item.variant_title)}</p>`
        : '';
    const image = item.image ? escapeHtml(item.image) : '';
    const imageMarkup = image
      ? `<img src="${image}" alt="" width="88" height="88" loading="lazy">`
      : '<span class="fb-cart-drawer__item-placeholder" aria-hidden="true"></span>';

    return `<article class="fb-cart-drawer__item" data-line-key="${escapeHtml(item.key)}">
      <a href="${escapeHtml(item.url)}" class="fb-cart-drawer__item-media">${imageMarkup}</a>
      <div class="fb-cart-drawer__item-info">
        <a href="${escapeHtml(item.url)}" class="fb-cart-drawer__item-title">${escapeHtml(item.product_title)}</a>
        ${variant}
        <div class="fb-cart-drawer__item-row">
          <div class="fb-cart-drawer__qty">
            <button type="button" class="fb-cart-drawer__qty-btn" data-fb-cart-qty-minus aria-label="Decrease quantity">−</button>
            <span class="fb-cart-drawer__qty-value" data-fb-cart-qty>${item.quantity}</span>
            <button type="button" class="fb-cart-drawer__qty-btn" data-fb-cart-qty-plus aria-label="Increase quantity">+</button>
          </div>
          <span class="fb-cart-drawer__item-price">${formatMoney(item.final_line_price)}</span>
        </div>
        <button type="button" class="fb-cart-drawer__remove" data-fb-cart-remove>Remove</button>
      </div>
    </article>`;
  };

  const renderCart = (cart) => {
    const count = cart.item_count || 0;
    const isEmpty = count === 0;

    if (countEl) countEl.textContent = count > 0 ? `(${count})` : '';
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price || 0);
    setHeaderCount(count);

    if (emptyState) emptyState.classList.toggle('is-hidden', !isEmpty);
    if (itemsRoot) {
      itemsRoot.classList.toggle('is-hidden', isEmpty);
      itemsRoot.innerHTML = isEmpty ? '' : (cart.items || []).map(renderItem).join('');
    }
    if (footer) footer.classList.toggle('is-hidden', isEmpty);
    if (checkoutBtn && !isEmpty) checkoutBtn.href = '/checkout';
  };

  const fetchCart = async () => {
    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('Cart fetch failed');
    return response.json();
  };

  const refresh = async () => {
    const cart = await fetchCart();
    renderCart(cart);
    return cart;
  };

  const changeLine = async (key, quantity) => {
    if (isLoading) return;
    isLoading = true;
    drawer.classList.add('is-updating');

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ id: key, quantity }),
      });
      if (!response.ok) throw new Error('Cart update failed');
      const cart = await response.json();
      renderCart(cart);
    } finally {
      isLoading = false;
      drawer.classList.remove('is-updating');
    }
  };

  const addItems = async (payload) => {
    if (isLoading) return null;
    isLoading = true;
    drawer.classList.add('is-updating');

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Add to cart failed');
      return refresh();
    } finally {
      isLoading = false;
      drawer.classList.remove('is-updating');
    }
  };

  const open = () => {
    if (isOpen) return;
    isOpen = true;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('fb-cart-open');
    window.setTimeout(() => drawer.querySelector('.fb-cart-drawer__panel')?.focus(), 50);
  };

  const close = () => {
    if (!isOpen) return;
    isOpen = false;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('fb-cart-open');
  };

  openTriggers.forEach((trigger) => {
    trigger.addEventListener('click', async (event) => {
      event.preventDefault();
      try {
        await refresh();
        open();
      } catch (error) {
        window.location.href = trigger.getAttribute('href') || '/cart';
      }
    });
  });

  closeTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => close());
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && isOpen) close();
  });

  itemsRoot?.addEventListener('click', (event) => {
    const item = event.target.closest('[data-line-key]');
    if (!item) return;
    const key = item.dataset.lineKey;
    const qtyEl = item.querySelector('[data-fb-cart-qty]');
    const currentQty = parseInt(qtyEl?.textContent, 10) || 0;

    if (event.target.closest('[data-fb-cart-qty-minus]')) {
      changeLine(key, Math.max(0, currentQty - 1));
    } else if (event.target.closest('[data-fb-cart-qty-plus]')) {
      changeLine(key, currentQty + 1);
    } else if (event.target.closest('[data-fb-cart-remove]')) {
      changeLine(key, 0);
    }
  });

  document.addEventListener('submit', async (event) => {
    const pdpForm = event.target.closest('[data-fb-pdp-form]');
    const cardForm = event.target.closest('[data-fb-card-add]');
    const form = pdpForm || cardForm;
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();

    const submitBtn = form.querySelector('[type="submit"], [data-fb-pdp-submit], [data-fb-card-add-btn]');
    if (!submitBtn || submitBtn.disabled) return;

    const originalText = submitBtn.textContent;
    submitBtn.disabled = true;
    submitBtn.textContent = pdpForm ? 'Adding...' : 'Adding...';

    try {
      const formData = new FormData(form);
      const variantId = formData.get('id');
      const quantity = parseInt(formData.get('quantity'), 10) || 1;
      await addItems({ items: [{ id: variantId, quantity }] });
      open();
      submitBtn.textContent = pdpForm ? originalText : 'Added';
      if (!pdpForm) submitBtn.classList.add('is-added');
      window.setTimeout(() => {
        submitBtn.textContent = originalText;
        submitBtn.classList.remove('is-added');
        submitBtn.disabled = false;
      }, pdpForm ? 0 : 1400);
      if (pdpForm) submitBtn.disabled = false;
    } catch (error) {
      submitBtn.textContent = originalText;
      submitBtn.disabled = false;
    }
  });

  window.FbCart = { open, close, refresh, addItems };

  refresh().catch(() => {});
})();
